export var ValueAssignable = {
    context: "ctx",
    structureMetadata: "md"
};
export var VariableFormats = {
    integer: 'integer',
    float: 'float'
};
